import React, { FC, ReactNode, useEffect, useState } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import { FloatingPosition, Tooltip } from '@mantine/core'
import cn from '../../lib/utils/cn'

interface SwitchProps {
	enabled: boolean
	onClick: () => void
	activeIcon?: ReactNode
	inactiveIcon?: ReactNode
	wrapperClassName?: ClassNameValue
	className?: ClassNameValue
	activeWrapperClassName?: ClassNameValue
	inactiveWrapperClassName?: ClassNameValue
	activeClassName?: ClassNameValue
	inactiveClassName?: ClassNameValue
	disabled?: boolean
	loading?: boolean
	tooltip?: string | null
	tooltipPosition?: FloatingPosition
	classNameWrapper?: ClassNameValue
}

const Switch: FC<SwitchProps> = ({
	enabled,
	onClick,
	activeIcon,
	inactiveIcon,
	wrapperClassName,
	className,
	activeWrapperClassName,
	inactiveWrapperClassName,
	activeClassName,
	inactiveClassName = 'fill-button-background',
	classNameWrapper,
	disabled,
	loading,
	tooltipPosition,
	tooltip,
}) => {
	const [currentState, setCurrentState] = useState(false)
	useEffect(() => {
		if (enabled !== currentState) {
			setCurrentState(enabled)
		}
	}, [enabled])

	const switchButton = (
		<button
			onClick={async () => {
				if (!disabled) {
					setCurrentState(!enabled)
					await onClick()
				}
			}}
			className={cn(
				'relative w-10 h-5 flex items-center rounded-xl transition-all group p-0',
				currentState
					? 'bg-positive border-0'
					: 'bg-white dark:bg-background-dark border border-stroke-light-hover',
				currentState ? activeWrapperClassName : inactiveWrapperClassName,
				!currentState && 'border border-stroke-dark',
				disabled &&
					'bg-background-light dark:bg-background-light-hover-dark border border-stroke-light-hover',
				// 	'bg-background-light border border-stroke-dark dark:opacity-50 dark:cursor-not-allowed',
				wrapperClassName
			)}
		>
			<div
				className={cn(
					'w-4 h-4 bg-sidebar-button-background rounded-full shadow-md transition-all flex items-center justify-center',
					currentState
						? disabled
							? 'translate-x-5'
							: 'translate-x-[22px]'
						: 'translate-x-0.5',
					currentState ? 'bg-white' : 'bg-negative',
					currentState ? activeClassName : inactiveClassName,
					disabled && 'bg-stroke-dark',
					className
				)}
			>
				{currentState ? activeIcon : inactiveIcon}
			</div>
		</button>
	)
	return tooltip ? (
		<Tooltip
			label={tooltip}
			position={tooltipPosition}
			className={cn(
				'absolute bg-text-secondary/90 text-white mx-auto py-1.5 px-3 rounded text-xs',
				classNameWrapper
			)}
			withArrow
			withinPortal={false}
			transitionProps={{ duration: 200 }}
			offset={3}
			disabled={false}
		>
			{switchButton}
		</Tooltip>
	) : (
		switchButton
	)
}

export default Switch
